import { render, staticRenderFns } from "./TemplateIndex.vue?vue&type=template&id=dd27c10a&scoped=true"
import script from "./TemplateIndex.vue?vue&type=script&lang=js"
export * from "./TemplateIndex.vue?vue&type=script&lang=js"
import style0 from "./TemplateIndex.vue?vue&type=style&index=0&id=dd27c10a&prod&scoped=true&lang=css"
import style1 from "./TemplateIndex.vue?vue&type=style&index=1&id=dd27c10a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd27c10a",
  null
  
)

export default component.exports